import styled from 'styled-components'
import {PrimaryStyledButton} from '../../../../styledComponents/Button'
import {Colors} from '../../../../styledComponents/Constants'

export const DisasterButton = styled(PrimaryStyledButton)`
    background-color: ${Colors.Disaster};
    border: none;
    box-shadow: 0 2px 0 0 ${Colors.DisasterShadow};

    :active {
        background-color: ${Colors.DisasterActive};
        box-shadow: 0 2px 0 0 ${Colors.DisasterShadow};
    }
`